import * as React from 'react'

const SvgSubtractIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.375 9.375h11.25v1.25H4.375v-1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgSubtractIcon
